export function deleteAttachmentsReducer(state, action) {
    const newState = Object.assign({}, state);
    action.payload.attachmentIds.forEach(id => delete newState[id]);
    return newState;
}
//# sourceMappingURL=deleteAttachmentsReducer.js.map